/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Contactsource1Inputs */

const de__field_contactsource1 = /** @type {(inputs: _Field_Contactsource1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktquelle Sonstiges`)
};

/**

* @param {_Field_Contactsource1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_contactsource1 = /** @type {((inputs?: _Field_Contactsource1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Contactsource1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_contactsource1(inputs)
});
export { _field_contactsource1 as "_field_contactSource" }